import { ITEM_TYPES } from '../config.js';

/** CRM lead cards from the enrichment stream. */
export function isStreamLead(item) {
    if (!item?.fromBackend) return false;
    return item.type === ITEM_TYPES.GOOD_LEAD || item.type === ITEM_TYPES.HOT_LEAD;
}

export function getLeadsCaughtCount(stats) {
    return Number(stats?.leadsCaught) || 0;
}
